import {Base} from '../../common/model/base.model';

export class GeoNazione extends Base {

  constructor(protected id: number,
              public denominazione: string
  ) {
    super(id);
  }

  public getLabel() {
    return this.denominazione;
  }

}
